import {atom, selectorFamily} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {serialize} from '../../../shared/utils/serialize-query-params';
import {api} from '../../api';
import {createQuery} from '../../lib';

const {getDashboard} = api.dashboard;

export type GetDashboardQueryParams = Parameters<typeof getDashboard>[0];

const getDashboardRefresh = atom<number>({
  key: 'getDashboardRefresh',
  default: 0,
});

const getDashboardQuery = selectorFamily({
  key: 'getDashboard',
  get(params: GetDashboardQueryParams) {
    return async ({get}) => {
      get(getDashboardRefresh);
      try {
        const {data} = await getDashboard(params, {paramsSerializer: {serialize}});
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useGetDashboardQuery = createQuery(getDashboardQuery, getDashboardRefresh);
